import type {
  BoardContent,
  BoardContentUpdateType,
} from '@/types/boardContent';

import {
  type IndustrialCaseDocument,
  parseIndustrialCaseDraftDocument,
} from './industrialCaseDocument';

export const INDUSTRIAL_CASE_BOARD_ID = 'industrial_case';

export type IndustrialCaseBoardItem = {
  contentId: number;
  status: BoardContent['status'];
  order: number;
  updatedAt: string;
  document: IndustrialCaseDocument;
};

/**
 * 게시판 글 하나를 고객 사례로 읽는다.
 *
 * 빈 칸을 허용하는 초안 기준으로 검사한다 — 임시저장본도 목록에 보이고 다시
 * 열려야 하기 때문이다. 게시할 수 있는지는 `status` 와 게시 시점의 검사가
 * 판단하고, 여기서는 "우리 형식의 문서인가"만 본다.
 */
export function parseIndustrialCaseBoardItem(
  content: BoardContent,
): IndustrialCaseBoardItem | null {
  const result = parseIndustrialCaseDraftDocument(content.add_data);
  if (!result.success) return null;

  return {
    contentId: content.idx,
    status: content.status,
    order: content.order,
    updatedAt: content.updated_at,
    document: result.data,
  };
}

/**
 * 게시판 저장 payload.
 *
 * `language` 를 넣지 않는다. `board_contents` 에 그런 컬럼이 없어서
 * 생성(POST)은 조용히 버리고 수정(PATCH)은 허용 필드 화이트리스트에 걸려
 * `허용되지 않은 필드입니다: language` 로 400 을 낸다.
 * 언어는 `add_data` 안의 문서에 들어있고, 목록·편집 화면도 그 값을 읽는다.
 */
export function buildIndustrialCaseBoardPayload({
  document,
  writer,
  status,
}: {
  document: IndustrialCaseDocument;
  writer: string;
  status: '1' | '2';
}): BoardContentUpdateType {
  return {
    bd_id: INDUSTRIAL_CASE_BOARD_ID,
    status,
    type: '2',
    writer,
    title: document.title,
    subtitle: document.summary,
    content: document.overview,
    add_data: document,
  };
}
